import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import ScrollableAnchor from 'react-scrollable-anchor';
import {STORES} from '../../common/constants';
import appStore from '../assets/img/appstore-badge.svg';
import googlePlay from '../assets/img/google-play-badge.png';
import mobile from '../assets/img/maquette_telephone.png';

class DownloadComp extends PureComponent {
  render() {
    return (
      <ScrollableAnchor id={'download'}>
        <Container className="container-full download-container">
          <Row>
            <Col xs={{span: 12}} md={{span: 5, offset: 1, order: 2}} className="download-text-area">
              <div className="title">{'Testez Clean Bill dès maintenant !'}</div>
              <div className="download-text">
                Téléchargez l'application <span className="pink">gratuitement </span>
                depuis l'Apple App Store ou le Google Play Store
              </div>
              <div className="store-buttons">
                <a href={STORES.APPLE_APP_STORE} target="_blank" rel="noopener noreferrer">
                  <img src={appStore} alt="app-store-download" className="apple-store-badge" />
                </a>
                <a href={STORES.GOOGLE_PLAY_STORE} target="_blank" rel="noopener noreferrer">
                  <img src={googlePlay} alt="google-play-download" className="google-play-badge" />
                </a>
              </div>
            </Col>
            <Col xs={{span: 12}} md={{span: 5, order: 1}} className="phone-img">
              <img src={mobile} alt="mobile-img" className="download-img" />
            </Col>
          </Row>
        </Container>
      </ScrollableAnchor>
    );
  }
}

DownloadComp.defaultProps = {
  img: '',
  title: '',
  text: '',
};

DownloadComp.propTypes = {
  img: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default DownloadComp;
